import { api, ISystemGuideApi } from "@/main/api/base";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { SystemGuideSearchRequest, SystemGuidRequest } from "@/main/models/request/systemGuideRequest";
import { SystemGuideDetailResponse, SystemGuideSearchGridResponse } from "@/main/models/response/systemGuideResponse";
import { AxiosResponse } from "axios";

const baseRoute: string = "SystemGuide";

export class SystemGuideApi extends ISystemGuideApi {
	save(request: SystemGuidRequest, file: File | null): Promise<AxiosResponse<Result<string>>> {
		const formData = new FormData();
		Object.entries(request).forEach(([key, value]) => {
			if (value !== null && value !== undefined) {
				if (Array.isArray(value)) {
					value.forEach((item) => {
						formData.append(`${key}[]`, item.toString());
					});
					return;
				}

				if (typeof value === "boolean") {
					formData.append(key, value ? "true" : "false");
					return;
				}

				if (typeof value === "number") {
					formData.append(key, value.toString());
					return;
				}

				formData.append(key, value);
			}
		});

		if (file) {
			formData.append("formFile", file);
		}

		return api.post(`${baseRoute}/save`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	getDetails(guidSystemGuide: string): Promise<AxiosResponse<Result<SystemGuideDetailResponse>>> {
		return api.get(`${baseRoute}/details`, { params: { guidSystemGuide } });
	}

	getSearchGrid(
		request: SystemGuideSearchRequest,
	): Promise<AxiosResponse<PaginationResponse<SystemGuideSearchGridResponse>>> {
		return api.get(`${baseRoute}/SearchGrid`, { params: { ...request } });
	}

	downloadImportFile(guidFileImport: string): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/DownloadImportFileGuide`, {
			params: { guidFileImport },
		});
	}
}
